<div *ngIf="game">
  <lms-breadcrumb [label]="game.name"></lms-breadcrumb>

  <mat-tab-group
    class="tab-group"
    #tabGroup
    animationDuration="0ms"
    disableRipple="true"
    (selectedTabChange)="tabsManager.setTab($event)"
  >
    <mat-tab label="data">
      <ng-template mat-tab-label>{{ 'nouns.data' | translate }}</ng-template>
      <ng-template matTabContent>
        <lms-game-editor [client]="client" [game]="game" (saved)="onUpdateGame($event)"> </lms-game-editor>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
